import { render, staticRenderFns } from "./textareaForm.vue?vue&type=template&id=18079c6a&scoped=true&"
import script from "./textareaForm.vue?vue&type=script&lang=js&"
export * from "./textareaForm.vue?vue&type=script&lang=js&"
import style0 from "./textareaForm.vue?vue&type=style&index=0&id=18079c6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18079c6a",
  null
  
)

export default component.exports